import { render, staticRenderFns } from "./ClientFunds.vue?vue&type=template&id=12a36254&"
import script from "./ClientFunds.vue?vue&type=script&lang=js&"
export * from "./ClientFunds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports